import React, { PureComponent } from 'react';

import Cta from '../cta/cta';
import FormErrorMessage from '../form-error-message/form-error-message';

import './save-discard-edits.scss';

class SaveDiscardEdits extends PureComponent {
  render() {
    const { save, discard, errorMessage, loading, saveText, discardText } = this.props;
    return (
      <div className="save-disc-edits">
        <div className="save-disc-edits__save">
          <Cta tag="button" text={saveText || "Save changes"} onClick={save} loading={loading} />
        </div>
        <div className="save-disc-edits__discard">
          <Cta tag="button" text={discardText || "Discard changes"} onClick={discard} bgColor="white" />
        </div>
        <FormErrorMessage
          isValid={errorMessage.length === 0}
          validationErrorMsg={errorMessage}
          noChevron
        />
      </div>
    );
  }
}

export default SaveDiscardEdits;